import { useCallback, useEffect, useState } from 'react';
import { Endpoint } from './base/endpoints';
import { useBaseService } from './base/useBaseService';

export default function useSet(setId: string) {
  const [set, setSet] = useState<{ name: string; itemsCount: number; items: any[] } | null>(null);

  const service = useBaseService(
    {
      queryKey: ['set', setId],
      endpoints: {
        get: Endpoint.getSet,
        update: Endpoint.updateSet,
      },
    },
    setId
  );
  const { isLoading, data } = service;

  const renameSet = useCallback(
    (name: string) => service.update({ data: { data: { attributes: { name } } } }),
    [service]
  );

  const updateSetImage = useCallback(
    (imageId: string) => service.update({ data: { data: { attributes: { icon_image_id: imageId } } } }),
    [service]
  );

  useEffect(() => {
    setSet(data);
  }, [data]);

  return { set, isLoading, service, renameSet, updateSetImage };
}
